import { Navigate, Outlet } from "react-router-dom";

const AuthRoutes = () => {
  const isAuthenticated = localStorage.getItem("token");

  return !isAuthenticated ? <Outlet /> : <Navigate to={"/dashboard"} />;
};

export default AuthRoutes;
